import WatchPage, { Wordmark } from "./WatchPage";

/**
 * Two routes, read straight off the path (no router for two shapes):
 *   /v/<slug>  the watch page
 *   /e/<slug>  the embed (player only), what the oEmbed iframe points at
 * Anything else is a quiet holding page: this host is not a catalogue.
 */
export function routeOf(
  pathname: string
): { slug: string; embed: boolean } | null {
  const m = /^\/(v|e)\/([A-Za-z0-9_-]{8,32})\/?$/.exec(pathname);
  return m ? { slug: m[2], embed: m[1] === "e" } : null;
}

export default function App() {
  const route = routeOf(window.location.pathname);
  if (!route) {
    return (
      <div className="unavailable">
        <Wordmark />
        <h1>Nenda Video</h1>
        <p>Videos here are shared by link.</p>
      </div>
    );
  }
  return <WatchPage slug={route.slug} embed={route.embed} />;
}
